/* eslint-disable */
import React, { useEffect, useReducer, useState } from 'react';
import { AccordionSection } from 'mapcontrols/components/subComponents';
import { INSPECTION_RESULTS_FILTERS, INSPECTION_RESULTS_FILTERS_NAMES } from 'mapcontrols/constants';
import { BaseSelect, Button, Loader } from 'ui-kit';
import * as Styled from './styles';
import { BUTTON_TYPES } from '_constants';
import { RadioGroup } from './InspectionSectionComponents/RadioGroup';
import { RadioItem } from './InspectionSectionComponents/RadioItem';
import { SubPanel } from './InspectionSectionComponents/SubPanel';
import { ACTIONS, formReducer, FORM_STATE } from './reducer';
import { applyFilters } from '_entities/old/Filter/filter.actions';
import { FILTER_FIELDS } from '_constants/old/filters';
import { useDispatch } from 'react-redux';
import { getAgenciesList } from '_entities/User/User.actions';
import moment from 'moment';
import axios from 'axios';
import apiData from '_entities/old/api/config';
import ExportDataDropDown from 'ui-kit/old/ExportDataDropDown';
import { notification } from 'utils/services';

const { baseUrl } = apiData;

const getAzInspectionResultsData = async ({ params, isPublic }) => {
  const token = localStorage.getItem('Authorization');
  return axios.get(`${baseUrl}${isPublic ? apiData.retailerPublicCSV : apiData.retailerCSV}${params}`, {
    headers: {
      ...(!isPublic && { Authorization: `Token ${token}` }),
    },
  });
};

const EXPORT_DATA_OPTIONS_NAMES = {
  DOWNLOAD: 'Download',
  EMAIL: 'Send to email',
};

const EXPORT_DATA_OPTIONS = [
  {
    label: 'Download',
    value: 'Download',
  },
  {
    label: 'Send to email',
    value: 'Send to email',
  },
];

const InspectionResults = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  getApi = () => {},
  setCurrentPage = () => {},
  isPublic = false,
  inspectionFailureRateSelection = null,
  onInspectionFailureRateMapFilter = () => {},
  locationSearch = '',
}) => {
  const [exportValue, setExportValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [agenciesList, setAgenciesList] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState({ id: '', name: '', label: ' - ', value: '', key: '' });
  const [appliedFilter, setAppliedFilter] = useState(INSPECTION_RESULTS_FILTERS_NAMES.all_current_retailers);
  const [selectedFilter, setSelectedFilter] = useState(INSPECTION_RESULTS_FILTERS_NAMES.all_current_retailers);
  const [stateForm, formDispatch] = useReducer(formReducer, FORM_STATE);
  const [isDisabled, setIsDisabled] = useState(false);
  const dispatch = useDispatch();

  const loadAgencies = async () => {
    try {
      const res = await dispatch(getAgenciesList());
      const parsedOptions = res?.data?.map((el) => ({
        id: el?.id,
        label: el?.attributes.name,
        name: el?.attributes.name,
        value: el?.id,
        key: el?.attributes.name,
      }));
      setAgenciesList([{ id: '', name: '', label: ' - ', value: '', key: '' }].concat(parsedOptions));
    } catch (error) {
      console.log('getAgenciesList', error);
    }
  };

  useEffect(() => {
    if (!isPublic) loadAgencies();
  }, []);

  useEffect(() => {
    switch (selectedFilter) {
      case INSPECTION_RESULTS_FILTERS_NAMES.retailers_failing:
        setIsDisabled(!stateForm.retailers_failing.startDate || !stateForm.retailers_failing.endDate);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.retailers_passing:
        setIsDisabled(!stateForm.retailers_passing.startDate || !stateForm.retailers_passing.endDate);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.inspection_failure_rate_by:
        setIsDisabled(
          !stateForm.inspection_failure_rate_by.startDate ||
            !stateForm.inspection_failure_rate_by.endDate ||
            !stateForm.inspection_failure_rate_by.value,
        );
        return;

      default:
        return setIsDisabled(false);
    }
  }, [stateForm, selectedFilter]);

  const handleSelect = (value) => {
    setSelectedAgency(value);
  };

  const handleStateForm = ({ value, type, dateType }) => {
    if (type === 'current_retailers_failing_inspection') {
      formDispatch({ type: ACTIONS.SET_FAILING_COUNT, payload: value });
    } else {
      formDispatch({
        type: ACTIONS.SET_DATE_RANGE,
        payload: value,
        filterType: type,
        dateType,
      });
    }
  };

  const handleLoadFilter = async (filters) => {
    await dispatch(applyFilters(filters));
    await getApi({ filters, page: 1 });
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    const agencyId = selectedAgency?.id || null;
    switch (selectedFilter) {
      case INSPECTION_RESULTS_FILTERS_NAMES.all_current_retailers:
        handleLoadFilter({
          [FILTER_FIELDS.IS_CURRENT]: ['t'],
          ...(agencyId && { [FILTER_FIELDS.AGENCY_ID]: agencyId }),
        });
        setAppliedFilter(selectedFilter);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.current_retailers_never_inspected:
        handleLoadFilter({
          [FILTER_FIELDS.IS_CURRENT]: ['t'],
          [FILTER_FIELDS.NO_VISIT_TYPE]: 'any,ever',
          ...(agencyId && { [FILTER_FIELDS.AGENCY_ID]: agencyId }),
        });
        setAppliedFilter(selectedFilter);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.current_retailers_failing_inspection:
        handleLoadFilter({
          [FILTER_FIELDS.IS_CURRENT]: ['t'],
          [FILTER_FIELDS.MINOR_VIOLATION_COUNT_GRT_AZ]: stateForm.current_retailers_failing_inspection.value,
          ...(agencyId && { [FILTER_FIELDS.AGENCY_ID]: agencyId }),
        });
        setAppliedFilter(selectedFilter);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.retailers_failing:
        handleLoadFilter({
          [FILTER_FIELDS.RETAILERS_FAILING_INSPECTION_RANGE]: `${moment(stateForm.retailers_failing.startDate).format(
            'YYYY-MM-DD',
          )},${moment(stateForm.retailers_failing.endDate).format('YYYY-MM-DD')}`,
          ...(agencyId && { [FILTER_FIELDS.AGENCY_ID]: agencyId }),
        });
        setAppliedFilter(selectedFilter);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.retailers_passing:
        handleLoadFilter({
          [FILTER_FIELDS.RETAILERS_PASSING_INSPECTION_RANGE]: `${moment(stateForm.retailers_passing.startDate).format(
            'YYYY-MM-DD',
          )},${moment(stateForm.retailers_passing.endDate).format('YYYY-MM-DD')}`,
          ...(agencyId && { [FILTER_FIELDS.AGENCY_ID]: agencyId }),
        });
        setAppliedFilter(selectedFilter);
        return;
      case INSPECTION_RESULTS_FILTERS_NAMES.inspection_failure_rate_by:
        const polytype = stateForm.inspection_failure_rate_by.value.value;
        const startDate = stateForm.inspection_failure_rate_by.startDate;
        const endDate = stateForm.inspection_failure_rate_by.endDate;

        onInspectionFailureRateMapFilter({
          type: 'inspection_failure_rate',
          agencyId: agencyId,
          polytype: polytype,
          startDate: startDate,
          endDate: endDate,
        });
        return;
      default:
        break;
    }
  };

  const handleClearInspectionFailureRate = () => {
    onInspectionFailureRateMapFilter({
      type: 'clear_inspection_failure_rate',
    });

    formDispatch({
      type: ACTIONS.RESET_INSPECTION_FAILURE_RATE,
    });

    setSelectedFilter('');
  };

  const handleGenerateReport = async (params = '', email = false) => {
    try {
      setIsLoading(true);
      const res = await getAzInspectionResultsData({ params, isPublic });

      if (params && res.data && !email) {
        try {
          const csvData = res.data;
          const contentDisposition = res?.headers['content-disposition'];
          let fileName = `${appliedFilter}.csv`;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+?)"/);
            if (match && match[1]) {
              fileName = match[1];
            }
          }

          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('CSV download failed:', error);
        }
      }

      if (email) {
        notification.success('The file has been successfully generated and sent to your email address');
      }
    } catch (err) {
      notification.error('Something went wrong during the request');
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportDataChange = ({ value }) => {
    setExportValue(value);
    switch (value) {
      case EXPORT_DATA_OPTIONS_NAMES.DOWNLOAD:
        handleGenerateReport(`${locationSearch}&export-format=csv`);
        break;
      case EXPORT_DATA_OPTIONS_NAMES.EMAIL:
        handleGenerateReport(locationSearch, true);
        break;
      default:
    }
  };

  return (
    <AccordionSection
      title="Inspection Results"
      id="inspectionResults"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {isLoading && <Loader />}
      <Styled.AgencySelectionWrapper>
        {!isPublic && (
          <BaseSelect
            name="agency"
            labelText="Agency"
            options={agenciesList}
            value={selectedAgency}
            onChange={(selectedValue) => handleSelect(selectedValue)}
            inputId="agency-results"
          />
        )}
      </Styled.AgencySelectionWrapper>
      <RadioGroup value={selectedFilter} onChange={setSelectedFilter} name="inspection_filters">
        {INSPECTION_RESULTS_FILTERS.map((filter) => (
          <RadioItem key={filter.id} value={filter.id} label={filter.label}>
            {filter.subpanel && <SubPanel type={filter.id} stateForm={stateForm} handleStateForm={handleStateForm} />}
          </RadioItem>
        ))}
      </RadioGroup>

      <Styled.ButtonWrapper>
        <Button onClick={handleApplyFilter} disabled={isDisabled} text="Apply Filter" variant={BUTTON_TYPES.DARK} />
        {selectedFilter !== INSPECTION_RESULTS_FILTERS_NAMES.inspection_failure_rate_by && (
          <>
            {isPublic ? (
              <Button
                onClick={() => handleGenerateReport(`${locationSearch}&export-format=csv`)}
                text="Export Data"
                variant={BUTTON_TYPES.DARK}
              />
            ) : (
              <ExportDataDropDown
                onChange={handleExportDataChange}
                value={exportValue}
                options={EXPORT_DATA_OPTIONS}
                placeholder={'Download/Email'}
                isDisabled={isLoading}
              />
            )}
          </>
        )}
        {inspectionFailureRateSelection &&
          inspectionFailureRateSelection.activeLayer !== 'no_inspection_failure_rate' && (
            <Button onClick={handleClearInspectionFailureRate} text="Clear Layer" variant={BUTTON_TYPES.DARK} />
          )}
      </Styled.ButtonWrapper>
    </AccordionSection>
  );
};

export default InspectionResults;
